import { routerStyxie } from '@/router/styxieBridge'
import { useProfileAccountStore } from '@/stores/profileAccount'

Styxie.Initializers.ProfileAccount = routerStyxie({
  actions: ['show'],
  hydrate: (props, pinia) => useProfileAccountStore(pinia).initialize(props)
})
